/**
 * Max save integer value
 *
 * @ignore
 * @type {number}
 */
export const MAX_SAFE_INTEGER = 0x1fffffffffffff;